import  { useRef } from 'react'

interface TimelineProps {
  years: string[]
  activeYear: string
  onYearChange: (year: string) => void
}

const Timeline = ({ years, activeYear, onYearChange }: TimelineProps) => {
  const timelineRef = useRef<HTMLDivElement>(null)

  const scrollToSection = (year: string) => {
    const section = document.getElementById(`section-${year}`)
    if (section) {
      const offset = window.innerWidth >= 1024 ? 100 : 50
      const elementPosition = section.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - offset
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
    onYearChange(year)
  }

  return (
    <>
      {/* Desktop Timeline */}
      <div className="hidden lg:block">
        <div 
          ref={timelineRef} 
          className=""
        >
          <div className="flex flex-col gap-4">
            {years.map((year) => (
              <div key={year} className="flex flex-col gap-1">
                <button
                  onClick={() => scrollToSection(year)}
                  className={`text-left text-lg font-satoshi leading-relaxed transition-all duration-200 p-2 rounded ${
                    activeYear === year 
                      ? 'text-gray-100 font-medium bg-wine-100/10' 
                      : 'text-gray-500 font-normal hover:text-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {year}
                </button>
                {activeYear === year && (
                  <div className="w-8 h-0.5 bg-wine-100 rounded-full ml-2"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Timeline */}
      <div className="lg:hidden">
        <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold font-satoshi text-gray-900 mb-4">Timeline</h3>
          <div className="flex overflow-x-auto gap-3 pb-2">
            {years.map((year) => (
              <button
                key={year}
                onClick={() => scrollToSection(year)}
                className={`flex-shrink-0 px-4 py-2 rounded-full font-semibold font-satoshi transition-colors ${
                  activeYear === year
                    ? 'bg-wine-100 text-white'
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {year}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Timeline